"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reselect_1 = require("reselect");
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var UIActionsToast_1 = require("../../UIActionsToast");
/**
 * Renders the errors in a containing ErrorList React Context as toasts (UIActionsToast).
 * Deduplicates error messages so that, at most, one of any given message is shown.
 */
var ErrorToasts = /** @class */ (function (_super) {
    __extends(ErrorToasts, _super);
    function ErrorToasts() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // tslint:disable-next-line: typedef
        _this.memoizedGetUniqueErrorMessages = reselect_1.defaultMemoize(getUniqueErrorMessages);
        return _this;
    }
    ErrorToasts.prototype.renderToastForMessage = function (message, key) {
        switch (message) {
            case data_catalog_shared_1.getToastMessageForErrorCode('BACKFILL_RUNNING'):
                // show a warning toast instead of a full blown error toast
                return React.createElement(UIActionsToast_1.UIActionsToast, { key: key, type: 'warning', text: message });
            case data_catalog_shared_1.getToastMessageForErrorCode('PERMISSIONS_MODE_SWITCHED'):
                // we don't expect to hit this, but if we do, log it and don't render a toast
                // tslint:disable-next-line:no-console
                console.log(data_catalog_shared_1.getToastMessageForErrorCode('PERMISSIONS_MODE_SWITCHED'));
                return null;
            default:
                return React.createElement(UIActionsToast_1.UIActionsToast, { key: key, type: 'error', text: message });
        }
    };
    ErrorToasts.prototype.render = function () {
        var _this = this;
        return (React.createElement(data_catalog_shared_1.ErrorListContext.Consumer, null, function (errorList) {
            var errorMessages = _this.memoizedGetUniqueErrorMessages(errorList.errors);
            return errorMessages.map(function (message, i) {
                return _this.renderToastForMessage(message, i);
            });
        }));
    };
    return ErrorToasts;
}(React.Component));
exports.ErrorToasts = ErrorToasts;
function getUniqueErrorMessages(errors) {
    var errorMessages = [];
    var seenErrorMessages = {};
    for (var _i = 0, errors_1 = errors; _i < errors_1.length; _i++) {
        var error = errors_1[_i];
        var errorMessage = error.errorMessage;
        if (!seenErrorMessages[errorMessage]) {
            seenErrorMessages[errorMessage] = true;
            errorMessages.push(errorMessage);
        }
    }
    return errorMessages;
}
exports.getUniqueErrorMessages = getUniqueErrorMessages;
//# sourceMappingURL=ErrorToasts.js.map